export const firebaseConfig = {
  apiKey: 'AIzaSyDjLe_ip2R1RpCedQZarYL9QfvCWGDC4yI',
  authDomain: 'http://aerobic-polygon-831.firebaseapp.com/',
  databaseURL: 'https://aerobic-polygon-831.firebaseio.com/',
  projectId: 'aerobic-polygon-831',
  storageBucket: 'http://aerobic-polygon-831.appspot.com/',
  messagingSenderId: '713342644611',
  appId: '1:713342644611:web:e1b2449723fede49',
  measurementId: 'G-716G1PN81D',
};
